import { defineComponent, toRefs, ref, provide } from 'vue'
import classes from '@/assets/styles/my-table.module.less'
import useResizeColumnsWidth from './useResizeColumnsWidth'
import useResizeRowsHeight from './useResizeRowsHeight'
import MyBody from './body'
import MyHeader from './header'
import useRows from './useRows'
import useColumns from './useColumns'
import Loading from '@/components/Loading'
import useHover from './useHover'
// import { useI18n } from 'vue-i18n'
export default defineComponent({
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: true
    },
    tableId: {
      type: String,
      default: ''
    }
  },
  setup (props, { slots }) {
    const { columns, data, loading, tableId } = toRefs(props)
    const leftBodyRef = ref()
    const mainBodyRef = ref()
    const tableRef = ref()
    const bodyRef = ref()
    const resizeLineVerticalRef = ref()
    const resizeLineHorizontalRef = ref()
    const resizeLineVerticalBolderRef = ref()
    const resizeLineHorizontalBolderRef = ref()
    const { rowsHeight, gridTemplateRows } = useRows(
      data,
      leftBodyRef,
      mainBodyRef,
      tableId
    )
    const {
      columnsWidth,
      leftColumns,
      mainColumns,
      leftGridTemplateColumns,
      mainGridTemplateColumns,
      collapseColumns
    } = useColumns(columns, tableId)
    const {
      hoveredKrId,
      removeBodyHoverEventListener,
      addBodyHoverEventListener
    } = useHover(bodyRef, data)
    useResizeColumnsWidth(tableRef, columnsWidth, resizeLineVerticalRef, resizeLineVerticalBolderRef, addBodyHoverEventListener, removeBodyHoverEventListener, tableId)
    useResizeRowsHeight(tableRef, rowsHeight, resizeLineHorizontalRef, resizeLineHorizontalBolderRef, addBodyHoverEventListener, removeBodyHoverEventListener, tableId)
    provide('hoveredKrId', hoveredKrId)
    provide('slots', slots)

    // const { t } = useI18n()

    return () => (
      <div className={classes.container}>
        <div className={classes.table} ref={tableRef}>
          <div className={[classes.header]}>
            <div className={classes['left-header']}>
              <MyHeader
                columns={leftColumns.value}
                columnsWidth={columnsWidth.value}
                collapseColumns={collapseColumns.value}
                tableId={ tableId.value}
              ></MyHeader>
            </div>
            <div className={classes['main-header']}>
              <MyHeader
                columns={mainColumns.value}
                columnsWidth={columnsWidth.value}
                collapseColumns={ collapseColumns.value }
                tableId={ tableId.value}
                ></MyHeader>
            </div>
          </div>
          <div ref={ bodyRef } className={[classes.body]}>
            <div
              className={classes['left-body']}
              ref={leftBodyRef}
              style={{
                'grid-template-rows': gridTemplateRows.value,
                'grid-template-columns': leftGridTemplateColumns.value
              }}
            >
              <MyBody columns={leftColumns.value} data={data.value} collapseColumns={ collapseColumns.value }></MyBody>
            </div>
            <div
              className={classes['main-body']}
              ref={mainBodyRef}
              style={{
                'grid-template-rows': gridTemplateRows.value,
                'grid-template-columns': mainGridTemplateColumns.value
              }}
            >
              <MyBody columns={mainColumns.value} data={data.value} collapseColumns={ collapseColumns.value }></MyBody>
            </div>
          </div>
        </div>
        {loading.value && <Loading className={classes.loading} />}
        {!loading.value && !data.value.length &&
          <a-empty
          image={require('@/assets/images/empty-okr-list.png')}
          image-style={{ height: '30%' }}
          class={classes.empty}
        />
        }
        <div ref={ resizeLineVerticalRef } className={ [classes['resize-line-vertical']]}></div>
        <div ref={ resizeLineHorizontalRef } className={ [classes['resize-line-horizontal']]}></div>
        <div ref={ resizeLineVerticalBolderRef } className={ [classes['resize-line-vertical'], classes['resize-line-vertical-bolder']].join(' ')}></div>
        <div ref={ resizeLineHorizontalBolderRef } className={ [classes['resize-line-horizontal'], classes['resize-line-horizontal-bolder']].join(' ')}></div>
      </div>
    )
  }
})
